import { PerimeterSearchContext } from "@App/contexts/apis/PerimeterSearchContext";
import { apolloClient } from "@App/graphql/client";
import { GET_SLOT, type SlotQuery } from "@App/graphql/queries/getSlot";
import { useGaragesRequestFromStore } from "@App/hooks/api/graphql/perimeterSearch/requests/factories/useGaragesRequestFromStore";
import { actionCreators, type State, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

export const useGarageParameters = () => {
  const dispatch = useDispatch();
  const { chooseGarage, chooseSlot } = bindActionCreators(actionCreators, dispatch);
  const [searchParams] = useSearchParams();

  const perimeterSearchApi = useContext(PerimeterSearchContext);

  const garage = useSelector((state: State) => state.orders.garage);
  const garageQuery = parseInt(searchParams.get("garage"));
  const slotQuery = parseInt(searchParams.get("slot"));
  const slotSessionQuery = searchParams.get("session");

  const service = useSelector((state: State) => state.orders.service);

  const request = useGaragesRequestFromStore({ id: garageQuery });

  useEffect(() => {
    if (!request) return;

    async function getGarage() {
      const garage = await perimeterSearchApi.getGarage(request);
      chooseGarage(garage);
    }
    // get garage from api if not in state
    if (garageQuery && (!garage || garage.id !== garageQuery) && service) {
      getGarage();
    }
  }, [service, garage, garageQuery, request]);

  useEffect(() => {
    if (slotQuery && slotSessionQuery) {
      apolloClient
        .query<SlotQuery>({
          query: GET_SLOT,
          variables: {
            id: slotQuery,
            sessionId: slotSessionQuery,
          },
        })
        .then((result) => {
          chooseSlot(result.data.slot);
        });
    }
  }, [slotQuery, slotSessionQuery]);

  const garageQueryParams = (): Record<string, string> => {
    return {
      // add garage if existing
      ...(store.getState().orders.garage && {
        garage: store.getState().orders.garage.id.toString(),
      }),
    };
  };

  return { garageQueryParams };
};
